<template>
  <div>
    <section>
      <b-row>
        <b-col cols="2">
          <b-form-group :label="$t('objects.with')">
            <flat-pickr
              id="start-date"
              v-model="query_params.start_date"
              class="form-control bg-white"
              style="max-width: 250px;"
              :config="configdateTimePicker"
              @on-change="refresh"
            />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group :label="$t('objects.by')">
            <flat-pickr
              v-model="query_params.end_date"
              class="form-control bg-white"
              style="max-width: 250px;"
              :config="configdateTimePicker"
              @on-change="refresh"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group :label="$t('objects.apartment_block')">
            <v-select
              v-model="query_params.apartment"
              :options="GET_APARTMENTS"
              label="title"
              :reduce="apartment => apartment.id"
              @input="apartmentSelect"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group :label="$t('objects.section')">
            <v-select
              v-model="query_params.section"
              :options="GET_SECTIONS"
              label="title"
              :reduce="section => section.id"
              :disabled="!query_params.apartment"
              @input="sectionSelect"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group :label="$t('objects.floor')">
            <v-select
              v-model="query_params.stage"
              :options="GET_STAGES"
              label="title"
              :reduce="stage => stage.id"
              :disabled="!query_params.section"
              @input="refresh"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </section>
    <section>
      <b-card no-body>
        <b-table
          id="price-history-table"
          :items="GET_PRICE_HISTORY.results"
          :fields="fields"
          :tbody-tr-class="['tableRowClass']"
          head-variant="dark"
          show-empty
          small
          :empty-text="$t('general.no_records_to_show')"
          :current-page="query_params.page"
        >
          <template #head()="{ label }">
            {{ $t(label) }}
          </template>
          <template #empty>
            <div class="text-center">
              {{ $t('general.no_records_to_show') }}
            </div>
          </template>
        </b-table>
        <!-- pagination -->
        <!-- style="border-top: 1px solid lightgrey;" -->
        <div class="d-flex justify-content-between align-items-center flex-wrap mb-75 bg-white p-1">
          <div class="d-flex align-items-center mb-0">
            <span class="text-nowrap text-black ml-1">
              {{ $t('generals.show_from') }}
            </span>
            <b-form-select
              v-model="query_params.page_size"
              :options="['5','10','15']"
              class="mx-1 text-black"
              @change="refresh"
            />
            <!-- <span class="text-nowrap text-black"> {{$t('pagination.entries')}} </span> -->
          </div>
          <div class="mb-1">
            <b-pagination
              v-model="query_params.page"
              :total-rows="GET_PRICE_HISTORY.count"
              :per-page="query_params.page_size"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @change="refresh"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </b-card>
    </section>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BTable,
  BPagination,
  BFormSelect,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Russian } from 'flatpickr/dist/l10n/ru'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    flatPickr,
    BCard,
    BTable,
    BPagination,
    BFormSelect,
    VSelect,
  },
  props: {
    apartment: {
      type: Number,
      required: false,
      default: null,
    },
    section: {
      type: Number,
      required: false,
      default: null,
    },
    stage: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      query_params: {
        start_date: '',
        end_date: '',
        id: this.$route.params.id,
        page: 1,
        page_size: 10,
        apartment: this.apartment,
        section: this.section,
        stage: this.stage,
      },
      currentPage: 1,
      configdateTimePicker: {
        altInput: true,
        altFormat: 'd.m.Y',
        dateFormat: 'Y-m-d',
        locale: Russian,
      },
      fields: [
        {
          key: 'apartment',
          label: 'objects.apartment_block',
          thClass: 'py-1',
        },
        {
          key: 'section',
          label: 'objects.section',
          thClass: 'py-1',
        },
        {
          key: 'stage',
          label: 'objects.floor',
          thClass: 'py-1',
        },
        {
          key: 'modified_date',
          label: 'objects.changed_date',
          formatter(value) {
            return new Date(value).toLocaleString().split(',')[0]
          },
          thClass: 'py-1',
        },
        {
          key: 'old_price_per_kv',
          label: 'objects.old_price',
          formatter(value) {
            return new Intl.NumberFormat('ru-Ru', {
              style: 'currency',
              currency: 'UZS',
            }).format(value)
          },
          thClass: 'py-1',
        },
        {
          key: 'new_price_per_kv',
          label: 'objects.new_price',
          formatter(value) {
            return new Intl.NumberFormat('ru-Ru', {
              style: 'currency',
              currency: 'UZS',
            }).format(value)
          },
          thClass: 'py-1',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('objects', ['GET_PRICE_HISTORY', 'GET_OBJECT_MEDIA']),
    ...mapGetters('apartments', ['GET_APARTMENTS']),
    ...mapGetters('sections', ['GET_SECTIONS']),
    ...mapGetters('stages', ['GET_STAGES']),
  },
  mounted() {
    this.FETCH_PRICE_HISTORY(this.query_params)
    this.FETCH_ONE_OBJECT(this.$route.params.id).then(() => {
      this.updateBreadCrumb()
    })
    this.FETCH_APARTMENTS_BY_OBJECT({
      id: this.$route.params.id,
    })
  },
  methods: {
    ...mapActions('objects', ['FETCH_PRICE_HISTORY', 'FETCH_ONE_OBJECT']),
    ...mapActions('apartments', ['FETCH_APARTMENTS_BY_OBJECT']),
    ...mapActions('sections', ['FETCH_APARTMENT_SECTIONS']),
    ...mapActions('stages', ['FETCH_STAGES_BY_SECTION']),
    ...mapMutations('breadcrumb', ['UPDATE_BREADCRUMB']),
    updateBreadCrumb() {
      const [first, second, third] = this.$_removeObjectConnection(
        this.$route.meta.breadcrumb,
      )
      second.text = this.GET_OBJECT_MEDIA.title
      second.to = second.to.replace(':id', this.$route.params.id)
      this.UPDATE_BREADCRUMB([first, second, third])
    },
    refresh() {
      this.FETCH_PRICE_HISTORY(this.query_params)
    },
    changePerPage() {
      this.refresh()
    },
    changePage() {
      this.refresh()
    },
    apartmentSelect() {
      if (this.query_params.apartment) {
        this.FETCH_APARTMENT_SECTIONS(this.query_params.apartment)
      }
      this.refresh()
    },
    sectionSelect() {
      if (this.query_params.section) {
        this.FETCH_STAGES_BY_SECTION({ id: this.query_params.section })
      }
      this.refresh()
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
